import http from '../lib/http';

export const FETCH_BRANCHES_START = 'FETCH_BRANCHES_START';
export const FETCH_BRANCHES_ERROR = 'FETCH_BRANCHES_ERROR';
export const FETCH_BRANCHES_SUCCESS = 'FETCH_BRANCHES_SUCCESS';

export function fetchBranches() {
    return {
        type: 'FETCH_BRANCHES',
        payload: {
            promise: getBranches()
        }
    };
}

async function getBranches() {
    const res = await http.get(`/app/branches-with-bars`);
    if (res.status < 300) return res.json();
    throw res;
}



// WEBPACK FOOTER //
// ./src/common/branches/actions.js